(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mincha-cake-counter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (scope) => {
      scope.querySelectorAll('[data-mf-counter]:not([data-ready])').forEach((counter) => {
        const addLabel = counter.querySelector('[data-mf-add-button]:not([disabled])')?.textContent.trim() || 'Add to bag';
        const soldOutLabel = 'Sold out';
        const cakes = [...counter.querySelectorAll('[data-mf-cake]')].map((cake) => ({
          cake,
          variants: JSON.parse(cake.querySelector('[data-mf-variants]').textContent),
          id: cake.querySelector('[data-mf-variant-id]'),
          price: cake.querySelector('[data-mf-price]'),
          button: cake.querySelector('[data-mf-add-button]'),
          status: cake.querySelector('[data-mf-status]'),
        }));

        const choose = (index) => {
          cakes.forEach(({ variants, id, price, button, status }) => {
            const variant = variants[index];
            status.textContent = '';
            if (!variant) {
              button.disabled = true;
              button.textContent = soldOutLabel;
              return;
            }
            id.value = variant.id;
            price.innerHTML = `${variant.price}<small></small>`;
            price.querySelector('small').textContent = variant.detail;
            button.disabled = !variant.available;
            button.textContent = variant.available ? addLabel : soldOutLabel;
          });
        };

        counter.querySelectorAll('.mf-feed input').forEach((input) =>
          input.addEventListener('change', () => choose(Number(input.value)))
        );

        cakes.forEach(({ cake, button, status }) => {
          const form = cake.querySelector('form');
          form.addEventListener('submit', async (event) => {
            event.preventDefault();
            button.disabled = true;
            try {
              const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
                method: 'POST',
                body: new FormData(form),
                headers: { Accept: 'application/json' },
              });
              const data = await response.json();
              if (!response.ok) throw new Error(data.description || data.message);
              // The basket drawer is rendered on the server, so reload and let it open itself.
              window.location.hash = 'basket';
              window.location.reload();
            } catch (error) {
              status.textContent = error.message || 'This cake could not be added. Please try again.';
              button.disabled = false;
            }
          });
        });

        counter.dataset.ready = 'true';
      });
    };
    initialise(document);
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mincha-flush-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (scope) => {
      scope.querySelectorAll('[data-mf-hero]:not([data-ready])').forEach((hero) => {
        const slides = [...hero.querySelectorAll('[data-mf-hero-slide]')];
        const buttons = [...hero.querySelectorAll('[data-mf-hero-to]')];
        let active = 0;
        const show = (index) => {
          active = (index + slides.length) % slides.length;
          slides.forEach((slide, i) => { slide.hidden = i !== active; slide.inert = i !== active; });
          buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === active)));
        };

        // Auto-switch between slides. Pauses while hovered, focused, off screen or in a background tab,
        // stops for good once someone picks a slide, and never runs for people who prefer reduced motion.
        const seconds = Number(hero.dataset.mfHeroAutoplay);
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let timer = null;
        let stopped = !seconds || reducedMotion || slides.length < 2;
        const pauses = new Set();
        const schedule = () => {
          clearTimeout(timer);
          hero.toggleAttribute('data-mf-hero-running', !stopped && pauses.size === 0);
          if (stopped || pauses.size) return;
          timer = setTimeout(() => { show(active + 1); schedule(); }, seconds * 1000);
        };
        const pause = (reason) => { pauses.add(reason); schedule(); };
        const resume = (reason) => { pauses.delete(reason); schedule(); };

        buttons.forEach((button) => button.addEventListener('click', () => {
          stopped = true;
          show(Number(button.dataset.mfHeroTo));
          schedule();
        }));
        hero.addEventListener('mouseenter', () => pause('hover'));
        hero.addEventListener('mouseleave', () => resume('hover'));
        hero.addEventListener('focusin', () => pause('focus'));
        hero.addEventListener('focusout', (event) => { if (!hero.contains(event.relatedTarget)) resume('focus'); });
        document.addEventListener('visibilitychange', () => (document.hidden ? pause('tab') : resume('tab')));
        new IntersectionObserver(([entry]) => (entry.isIntersecting ? resume('offscreen') : pause('offscreen')), { threshold: 0.25 }).observe(hero);

        // Fetch the other photographs early so each switch is a clean crossfade.
        slides.forEach((slide) => slide.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; }));

        show(0);
        schedule();
        hero.dataset.ready = 'true';
      });
    };
    initialise(document);
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const hero = event.target.closest('[data-mf-hero]');
      if (!hero) return;
      const index = [...hero.querySelectorAll('[data-mf-hero-slide]')].indexOf(event.target);
      hero.querySelector(`[data-mf-hero-to="${index}"]`)?.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mincha-flush-ordering"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Same origin point and radius as the basket drawer's delivery check.
    const counter = { lat: 51.5258, lon: -0.0877 };
    const radiusMiles = 5;
    const toRadians = (value) => (value * Math.PI) / 180;
    const milesFrom = (lat, lon) => {
      const a = Math.sin((toRadians(lat) - toRadians(counter.lat)) / 2) ** 2 +
        Math.cos(toRadians(counter.lat)) * Math.cos(toRadians(lat)) * Math.sin((toRadians(lon) - toRadians(counter.lon)) / 2) ** 2;
      return 3958.8 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    };
    const initialise = (scope) => {
      scope.querySelectorAll('[data-mf-postcode]:not([data-ready])').forEach((form) => {
        const result = form.parentElement.querySelector('[data-mf-postcode-result]');
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const value = form.postcode.value.trim().toUpperCase();
          if (!/^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/.test(value)) {
            result.textContent = 'Enter a full UK postcode, for example EC1V 1NR.';
            return;
          }
          result.textContent = 'Checking…';
          try {
            const response = await fetch(`https://api.postcodes.io/postcodes/${encodeURIComponent(value)}`);
            const data = await response.json();
            if (!response.ok || !data.result) throw new Error();
            const miles = milesFrom(data.result.latitude, data.result.longitude);
            result.textContent = miles <= radiusMiles
              ? `Good news, we deliver to ${value}. It is ${miles.toFixed(1)} miles from us.`
              : `${value} is ${miles.toFixed(1)} miles away, outside our delivery area. You can collect from us instead.`;
          } catch (_) {
            result.textContent = 'We could not find that postcode. Check it and try again.';
          }
        });
        form.dataset.ready = 'true';
      });
    };
    initialise(document);
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mincha-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      const heroes = scope.querySelectorAll('[data-mc-home-hero]:not([data-initialized])');
      heroes.forEach((hero) => {
        const slides = [...hero.querySelectorAll('[data-mc-hero-slide]')];
        const indicators = [...hero.querySelectorAll('[data-mc-hero-to]')];
        if (slides.length < 2) return;
        let active = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
        let pointerStart = null;
        slides.forEach((slide, index) => {
          const selected = index === active;
          slide.hidden = !selected;
          slide.inert = !selected;
          slide.setAttribute('aria-hidden', String(!selected));
        });
        const show = (next) => {
          const nextIndex = (next + slides.length) % slides.length;
          if (nextIndex === active) return;
          slides.forEach((slide, index) => {
            const selected = index === nextIndex;
            slide.classList.toggle('is-active', selected);
            slide.hidden = !selected;
            slide.inert = !selected;
            slide.setAttribute('aria-hidden', String(!selected));
          });
          active = nextIndex;
          indicators.forEach((button, index) => button.setAttribute('aria-pressed', String(index === active)));
          hero.dataset.activeSlide = String(active);
        };
        hero.querySelector('[data-mc-hero-prev]')?.addEventListener('click', () => show(active - 1, -1));
        hero.querySelector('[data-mc-hero-next]')?.addEventListener('click', () => show(active + 1, 1));
        indicators.forEach((button) => button.addEventListener('click', () => show(Number(button.dataset.mcHeroTo), Number(button.dataset.mcHeroTo) > active ? 1 : -1)));
        hero.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') show(active - 1, -1);
          if (event.key === 'ArrowRight') show(active + 1, 1);
        });
        hero.addEventListener('pointerdown', (event) => {
          if (event.target.closest('a,button,input,textarea,select')) return;
          pointerStart = { x: event.clientX, y: event.clientY };
        });
        hero.addEventListener('pointerup', (event) => {
          if (!pointerStart) return;
          const deltaX = event.clientX - pointerStart.x;
          const deltaY = event.clientY - pointerStart.y;
          pointerStart = null;
          if (Math.abs(deltaX) < 56 || Math.abs(deltaX) < Math.abs(deltaY) * 1.25) return;
          show(active + (deltaX < 0 ? 1 : -1), deltaX < 0 ? 1 : -1);
        });
        hero.addEventListener('pointercancel', () => { pointerStart = null; });
        hero.dataset.initialized = 'true';
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mincha-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.location.hash) return;

    const navigation = performance.getEntriesByType('navigation')[0];
    if (navigation && navigation.type === 'back_forward') return;

    const showHero = () => window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    if (document.readyState === 'complete') {
      showHero();
    } else {
      window.addEventListener('load', showHero, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mincha-product"]) return;
  try {
    
  (()=>{document.querySelectorAll('[data-product-page]').forEach((page)=>{page.querySelectorAll('.mc-product-variant input').forEach((input)=>input.addEventListener('change',(event)=>{page.querySelector('[data-product-price]').textContent=event.currentTarget.dataset.price}));page.querySelectorAll('[data-counted-input]').forEach((input)=>{const count=input.closest('.mc-product-field').querySelector('[data-character-count]');input.addEventListener('input',()=>{count.textContent=input.value.length})});page.querySelectorAll('[data-delivery-checker]').forEach((checker)=>{const input=checker.querySelector('[data-postcode]');const result=checker.querySelector('[data-delivery-result]');checker.querySelector('[data-check-delivery]').addEventListener('click',async()=>{const postcode=input.value.trim().replace(/\s+/g,'');if(!postcode){result.textContent=page.dataset.emptyPostcode;return}result.textContent=page.dataset.checkingPostcode;try{const response=await fetch(`https://api.postcodes.io/postcodes/${encodeURIComponent(postcode)}`);const data=await response.json();if(!response.ok||!data.result)throw new Error();const r=(value)=>value*Math.PI/180;const a=Math.sin((r(data.result.latitude)-r(51.5258))/2)**2+Math.cos(r(51.5258))*Math.cos(r(data.result.latitude))*Math.sin((r(data.result.longitude)-r(-.0877))/2)**2;const miles=3958.8*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));const template=miles<=5?page.dataset.localDelivery:page.dataset.nationalDelivery;result.textContent=template.replace('[miles]',miles.toFixed(1))}catch(_){result.textContent=page.dataset.invalidPostcode}})})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mincha-welcome-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-welcome-offer]');
    if (!root) return;
    const dialog = root.querySelector('[data-welcome-dialog]');
    const key = 'mincha-welcome-offer-seen';
    const open = () => { if (!dialog.open) dialog.showModal(); };
    const close = () => { if (dialog.open) dialog.close(); try { sessionStorage.setItem(key, '1'); } catch (_) {} };
    root.querySelector('[data-welcome-open]').addEventListener('click', open);
    root.querySelectorAll('[data-welcome-close]').forEach((button) => button.addEventListener('click', close));
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
    root.querySelector('[data-copy-code]')?.addEventListener('click', async (event) => {
      const code = root.querySelector('.mc-welcome__code strong')?.textContent?.trim();
      if (!code) return;
      try { await navigator.clipboard.writeText(code); event.currentTarget.textContent = 'Copied'; } catch (_) { event.currentTarget.textContent = code; }
    });
    try { if (!sessionStorage.getItem(key)) window.setTimeout(open, 1500); } catch (_) { window.setTimeout(open, 1500); }
  })();

  } catch(e) { console.error(e); }
})();
})();
